import Marquee from "react-fast-marquee";

const items = [
  "Brand Activations",
  "Trade Shows",
  "Custom Fabrication",
  "Logistics",
  "Experiential",
  "Rentals",
];

export default function EditorialMarquee() {
  return (
    <section className="overflow-hidden border-b border-white/10 bg-[#050505] py-12 md:py-16" data-testid="marquee">
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="text-outline font-display text-5xl font-bold uppercase tracking-tight md:text-8xl">
              {t}
            </span>
            <span className="h-3 w-3 rounded-full bg-[#FF3B30]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
